module.exports = __webpack_public_path__ + "ico-crypto-egld.svg?c9d5c6f2fb5be5164c08481803970575";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ico-crypto-egld.svg
// module id = 1156
// module chunks = 2